import { render, staticRenderFns } from "./SaleProductAboutComponent.vue?vue&type=template&id=18a18e65&scoped=true&"
import script from "./SaleProductAboutComponent.vue?vue&type=script&lang=js&"
export * from "./SaleProductAboutComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a18e65",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VImg})
